<template>
  <div class="page">
    <!-- :bodyStyle="{padding:'12px'}" -->
    <a-card title="余额充值" :bordered="false" :bodyStyle="{paddingTop:'0px'}"
            :headStyle="{borderBottom:'0px',fontSize:'18px'}">
      <a-row>
        <a-col :span="14">
          <a-form @submit="handleSubmit" :form="form">
            <a-row class="title-name">当前可提现金额 {{ amountData.accountAbleDrawCash }} 元</a-row>
            <a-form-item label="充值方式" v-bind="formItemLayout">
              <a-radio-group v-decorator="['radioSelected']" @change="onRadioChange">
                <!-- <a-radio :value="1">线下转账</a-radio> -->
                <a-radio :value="2">在线支付</a-radio>
              </a-radio-group>
            </a-form-item>
            <a-form-item label="充值金额" v-bind="formItemLayout">
              <a-input placeholder="请输入"
                       v-decorator="['amount', { rules: [{ required: true, message: '请输入充值金额' },{pattern: /^(?!0+(?:\.0+)?$)(?:[1-9]\d{0,6}|0)(?:\.\d{1,2})?$/, message: '请输入正确金额',}] }]"
              />
            </a-form-item>
            <a-form-item v-if="rechargType==1" label="上传银行电子回单" v-bind="formItemLayout">
              <div class="upload-box">
                <a-upload
                  :action="uploadFileUrl"
                  :multiple="false"
                  v-decorator="['url',{rules:[{required:true}]}]"
                  :showUploadList="false"
                  listType="picture-card"
                  @change="handleChange"
                >
                  <img v-if="imageUrl" :src="imageUrl" alt="avatar" class="selected-image"/>
                  <div v-else>
                    <a-icon type="plus"/>
                    <br>上传
                  </div>
                </a-upload>
              </div>
            </a-form-item>
            <a-form-item v-bind="formItemLayoutBtn">
              <a-button type="primary" htmlType="submit">提交充值</a-button>
            </a-form-item>
          </a-form>
        </a-col>
        <a-col :span="10">
          <detail-list v-if="rechargType==1" :col="1" title="请向下方账号转账付款并上传转账凭证">
            <detail-list-item term="账户名">{{ bankData.bankName }}</detail-list-item>
            <detail-list-item term="银行账号">{{ bankData.bankAccount }}</detail-list-item>
            <detail-list-item term="开户银行">{{ bankData.bankMan }}</detail-list-item>
          </detail-list>
          <div class="code-box" v-else>
            <div class="code-txt">输入金额并提交充值后，请扫描下方二维码完成支付</div>
            <div class="code-img"><img v-if='erWeiMaImageSrc' :src="erWeiMaImageSrc" alt=""></div>
          </div>
        </a-col>
      </a-row>
      <a-card :bordered="false" :bodyStyle="{padding:'0px'}" :headStyle="{borderBottom:'0px',paddingLeft:'0px'}">
        <a-row slot="title">
          <a-col :span="8">
            <span class="card-title">充值记录</span>
          </a-col>
        </a-row>
        <custom-page-table
          ref="table"
          rowKey="id"
          :columns="columns"
          :requestPromise="loadPromise"
        >
          <span slot="status" slot-scope="rowItem">
            <span v-if="rowItem.text==0">未支付</span>
            <span v-else-if="rowItem.text==1">充值成功</span>
            <span v-else>充值失败</span>
          </span>
          <span slot="largeBackAmountType" slot-scope="rowItem">
            {{ rowItem.text|transferTypeName }}
          </span>
        </custom-page-table>
      </a-card>
    </a-card>

  </div>
</template>

<script>
import formMixins from '../../../utils/mixins/formMixins'

export default {
  name: 'BalanceRecharge',
  mixins: [formMixins],
  data() {
    return {
      loading: false,
      imageUrl: '',
      erWeiMaImageSrc: '',
      amountData: {
        accountAbleDrawCash: 0
      },
      bankData: [],
      preventReSubmit: '',
      businessFileList: [],
      formItemLayoutBtn: {
        wrapperCol: {
          xxl: { offset: 3 },//≥1600px 响应式栅格，可为栅格数或一个包含其他属性的对象
          xl: { offset: 4 },//≥1200px 响应式栅格，可为栅格数或一个包含其他属性的对象
          lg: { offset: 5 },//≥992px 响应式栅格，可为栅格数或一个包含其他属性的对象
          sm: { offset: 5 },//≥768px 响应式栅格，可为栅格数或一个包含其他属性的对象
          md: { offset: 8 },//≥576px 响应式栅格，可为栅格数或一个包含其他属性的对象
          xs: { offset: 10 }//xs	<576px 响应式栅格，可为栅格数或一个包含其他属性的对象
        }
      },
      formItemLayout: {
        labelCol: {
          xxl: { span: 3 },
          xl: { span: 4 },
          lg: { span: 5 },
          sm: { span: 5 },
          md: { span: 8 },
          xs: { span: 10 }
        },
        wrapperCol: {
          xxl: { span: 21 },//≥1600px 响应式栅格，可为栅格数或一个包含其他属性的对象
          xl: { span: 20 },//≥1200px 响应式栅格，可为栅格数或一个包含其他属性的对象
          lg: { span: 19 },//≥992px 响应式栅格，可为栅格数或一个包含其他属性的对象
          sm: { span: 19 },//≥768px 响应式栅格，可为栅格数或一个包含其他属性的对象
          md: { span: 16 },//≥576px 响应式栅格，可为栅格数或一个包含其他属性的对象
          xs: { span: 14 }//xs	<576px 响应式栅格，可为栅格数或一个包含其他属性的对象
        }
      },
      timer: null,
      rechargType: 2,
      balanceData: [],
      loadPromise: params => this.getBalanceData(params),
      columns: [
        {
          title: '提交时间',
          dataIndex: 'createDt'
        },
        {
          title: '金额(元)',
          dataIndex: 'rechargeMoney'
        },
        {
          title: '充值方式',
          dataIndex: 'largeBackAmountType',
          scopedSlots: { customRender: 'largeBackAmountType' }
        },
        {
          title: '充值结果',
          dataIndex: 'status',
          scopedSlots: { customRender: 'status' }
        },
        {
          title: '备注',
          dataIndex: 'remark'
        }
      ]
    }
  },
  mounted() {
    this.form.setFieldsValue({
      radioSelected: 2
    })
    this.getPreventResubmitKey()
    this.getAmountData()
    //this.getBankData()
  },
  destroyed() {
    clearInterval(this.timer)
    this.timer = null
  },
  methods: {
    //电子数据上传
    handleChange(info) {
      if (info.file.status === 'uploading') {
        this.loading = true
        return
      }
      if (info.file.status === 'done') {
        const url = this.getLatestUrlFromFileList(info.fileList)
        // Get this url from response in real world.
        this.imageUrl = url
        this.loading = false
      }
    },
    //获取防重复码
    getPreventResubmitKey() {
      this.getHttpServices().getBaseService().get('preventResubmit/getPreventResubmitKey')
        .then(res => {
          this.getLogUtils().logWithTag('getPreventResubmitKey===============', res)
        }).catch(reason => {
        this.preventReSubmit = reason
        this.getLogUtils().logWithTag('getPreventResubmitKey===============', reason)
      })
    },
    //提交
    handleSubmit(e) {
      e.preventDefault()
      this.form.validateFields((err, values) => {
        if (!err) {
          this.getHttpServices().getOrderService().post('money/merchantRecharge', {
            merchantId: this.$store.getters.userInfo.merchantId,
            rechargePrice: values.amount,
            preventReSubmit: this.preventReSubmit
          })
            .then(res => {
              this.getLogUtils().logWithTag('================', res)
              this.getPreventResubmitKey()
              this.showQRCode(res)
              this.checkPayStatus(res)
              this.$message.success('提交成功')
              this.$refs.table.refresh()
            }).catch(reason => {
            this.$message.error('提交失败')
            this.showNetWorkErrorMessage(reason)
          })
        }
      })
    },
    //获取二维码图片地址
    showQRCode(orderNo) {
      const url = 'pay/order/qrcode/pay/' + orderNo + '/1'
      this.erWeiMaImageSrc = this.getAppConfig().payUrl + url
    },
    //二维码刷新
    checkPayStatus(orderNo) {
      if (!this.timer) {
        this.timer = setInterval(() => {
          const rechargeUrl = 'money/merchantRechargeIsOK/' + orderNo
          this.getHttpServices().getOrderService().post(rechargeUrl)
            .then(res => {
              this.getLogUtils().logWithTag('res=====================', res)
              if (res == 1) {
                this.$message.success('微信充值已成功！')
                clearInterval(this.timer)
                this.getAmountData()
                this.$refs.table.refresh(true)
                this.timer = null
                this.erWeiMaImageSrc = ''
                this.form.setFieldsValue({
                  amount: ''
                })
              }
            }).catch(err => {
            this.getLogUtils().logWithTag(err)
          })
        }, 1000)
      }
    },
    //表格数据
    getBalanceData(params) {
      return this.getHttpServices().getOrderService().post('money/exchange/amount/list', {
        limitDto: params,
        merchantId: this.$store.getters.userInfo.merchantId
      })
    },
    //获取商户余额
    getAmountData() {
      this.getHttpServices().getOrderService().post('money/getMerchantFunds').then(res => {
        this.amountData = res
      }).catch(reason => {
        this.showNetWorkErrorMessage(reason)
      })
    },
    //获取银行卡信息
    getBankData() {
      this.getHttpServices().getOrderService().post('largePayment/getBankInfoVo').then(res => {
        this.bankData = res
      }).catch(reason => {
        this.showNetWorkErrorMessage(reason)
      })
    },
    onRadioChange(e) {
      this.getLogUtils().logWithTag('radio checked', e.target.value)
      this.rechargType = e.target.value
    }
  }
}
</script>
<style scoped lang="less">
@import url("../../CustomPage.less");

.card-title {
  padding-left: 10px;
  border-left: 1px solid #FAAD14;
  line-height: 32px;
  margin-right: 5px;
}

.title-name {
  font-size: 15px;
  color: #000;
  padding-left: 2%;
}

.upload-box {
  margin-top: 14px;
  height: 104px;
  position: relative;
}

.code-box {
  .code-txt {
    font-size: 14px;
    color: #000;
    text-align: center;
  }

  .code-img {
    width: 202px;
    height: 202px;
    margin: 0 auto;
    border: 1px solid #444444;
    overflow: hidden;

    img {
      width: 200px;
      height: 200px;
    }
  }
}

.selected-image {
  width: 100px;
  height: 100px;
}
</style>